import component from '@/mixins/component'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
export default {
  name: 'layout_menu',
  mixins: [component],
  data () {
    return {
      ready: false,
      color: 'white',
      open: 'closed',
      subOpen: false,
      nextItem: [],
      social: [],
      lang: window.lang,
      sizeType: 'desktop'
    }
  },
  created () {
    this.$nextTick(() => {
      this.getMenus().then(() => {
        this.ready = true
      })
    })
  },
  watch: {
    ready () {
      this.$nextTick(() => {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        document.documentElement.style.setProperty('--h', '-25px')
        document.documentElement.style.setProperty('--o', '-25px')
        let transformValue = 0
        Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
          el.style.top = `${transformValue}px`
          if (el.querySelector('.sub-menu')) {
            el.setAttribute('data-subMenu', el.querySelector('.sub-menu').getBoundingClientRect().height)
          }
        })
        this.targetElement = this.$refs['mobile-menu']
      })
    },
    platform () {
      if (window.innerWidth < 813) {
        let transformValue = 0
        this.$nextTick(() => {
          Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
            el.style.top = `${transformValue}px`
            if (el.querySelector('.sub-menu')) {
              el.setAttribute('data-subMenu', el.querySelector('.sub-menu').getBoundingClientRect().height)
              // console.log(el.querySelector('.sub-menu').getBoundingClientRect().height)
            }
          })
          this.targetElement = this.$refs['mobile-menu']
        })
      }
    }
  },
  methods: {
    getMenus: async function () {
      return Promise.all([
        this.$store.getters.get('menu', `menu${window.lang !== 'en' ? '_' + window.lang : ''}`, true),
        this.$store.getters.get('menu', `social${window.lang !== 'en' ? '_' + window.lang : ''}`, true)
      ]).then(([menu, social]) => {
        this.menu = menu.items
        this.social = social.items
      })
    },

    toggleMenu () {
      if (this.open === 'closed') {
        this.open = 'opened'
        // scroll inactive
        disableBodyScroll(this.targetElement)
      } else {
        this.open = 'closed'
        // scroll inactive
        enableBodyScroll(this.targetElement)

        this.$refs['mobile-menu'].style.touchAction = 'auto'
        this.subOpen = false
        TweenMax.to(this.$refs['main-list'], 0.75, { paddingBottom: 0, ease: Power0.easeNone })
        Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
          setTimeout(() => {
            el.style.transform = `translateY(0px)`
            el.classList.remove('isOpen')
          }, 500)
        })
      }
      this.$refs['mobile-menu'].classList.toggle('hidden')
    },

    pageChange () {
      setTimeout(() => {
        enableBodyScroll(this.targetElement)
        this.open = 'closed'
        document.querySelector('html').classList.remove('preventScroll')
        this.subOpen = false
        Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
          setTimeout(() => {
            this.$refs['main-list'].style.paddingBottom = '0px'
            el.style.transform = `translateY(0px)`
            el.classList.remove('isOpen')
            this.$refs['mobile-menu'].classList.toggle('hidden')
          }, 700)
        })
      }, 300)
    },

    nextAside (e, item) {
      if (this.subOpen) {
        if (e.srcElement.classList.contains('isParent') || e.srcElement.classList.contains('sub-menu')) {
          this.subOpen = false
          Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
            el.style.transform = `translateY(0px)`
            el.classList.remove('isOpen')
          })
          this.$refs['main-list'].style.paddingBottom = '0px'
          document.documentElement.style.setProperty('--o', `0px`)
        }
      } else {
        this.subOpen = true
        e.srcElement.classList.add('isOpen')
        let subMenuHeight = e.srcElement.getAttribute('data-subMenu')
        this.$refs['main-list'].style.paddingBottom = `${subMenuHeight}px`
        document.documentElement.style.setProperty('--o', `${subMenuHeight - 20}px`)
        this.isOpen = true
        this.currentIndex = undefined
        Array.from(document.querySelectorAll('.main-links')).map((el, index) => {
          if (e.srcElement === el) {
            this.currentIndex = index
          }
          if (this.currentIndex) {
            if (index > this.currentIndex) {
              el.style.transform = `translateY(${subMenuHeight - 20}px)`
            }
          }
        })
      }
    },
    handleClick (e) {
      Array.from(document.querySelectorAll('.first-level li')).map(el => {
        el.classList.add('unovered')
      })
      setTimeout(() => {
        Array.from(document.querySelectorAll('.first-level li')).map(el => {
          el.classList.remove('unovered')
        }, 2000)
      })
    },
    resize () {

    }
  }
}
